import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/shipper/")({
  beforeLoad: () => {
    // TODO: 権限チェック と デフォルトページへのリダイレクト
  },
  component: () => <Outlet />,
});
